export default __webpack_public_path__ + "static/media/idrobios 1.eaf898eb.png";